import { useContext } from 'react';

import useFetchPropertyMetadata from 'components/domain/property/useFetchPropertyMetadata';
import LoadingPlaceholder from 'components/loader/LoadingPlaceholder';
import CalendarContext from 'pages/stackedCalendar/CalendarContext';
import useAppUser from 'hooks/useAppUser';
import { PricingUpdateStyled } from './PricingUpdates.styles';
import PricingUpdatesChannels from './PricingUpdatesChannels';
import PricingUpdatesDynamicTool from './PricingUpdatesDynamicTool';
import useFetchPropertyDynamicPricingTools from './useFetchPropertyDynamicPricingTools';

const PricingUpdates = () => {
  const { isOwner } = useAppUser();
  const { selectedProperty: propertyUid } = useContext(CalendarContext);
  const { enabledPricingTools, isLoading: isLoadingIntegrationSettings } =
    useFetchPropertyDynamicPricingTools(propertyUid, { enabled: !isOwner });
  const { data: propertyMetadata, isLoading: isLoadingPropertyMetadata } =
    useFetchPropertyMetadata({ propertyUid: propertyUid! });

  if (isOwner) {
    return null;
  }

  const isLoading = isLoadingIntegrationSettings || isLoadingPropertyMetadata;

  if (isLoading) {
    return (
      <PricingUpdateStyled>
        <LoadingPlaceholder linesCount={2.28} width="60%" />
      </PricingUpdateStyled>
    );
  }

  return (
    <PricingUpdateStyled data-testid="pricing-updates">
      <PricingUpdatesDynamicTool
        enabledPricingTools={enabledPricingTools}
        pricingMetadata={propertyMetadata?.pricingMetadata}
      />
      <PricingUpdatesChannels
        pricingMetadata={propertyMetadata?.pricingMetadata}
      />
    </PricingUpdateStyled>
  );
};

export default PricingUpdates;
